import { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';
import { hasUsedAts } from 'modules/orgDashboard/utils/ats';

export function promoteAts({ user }: { user: ApiUser | null }) {
  const isAdmin = (user?.orgs?.length || 0) > 0;

  const orgUsedAts = (user?.orgs.filter((org) => org.usedAts)?.length || 0) > 0;

  return isAdmin && !hasUsedAts() && !orgUsedAts;
}
